import { useState, useEffect } from 'react';

const usePreferredColorScheme = () => {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => setTheme(mediaQuery.matches ? 'dark' : 'light');

    handleChange(); // Set the initial theme
    mediaQuery.addEventListener('change', handleChange); // Listen for changes

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return theme;
};

export default usePreferredColorScheme;
